import React from 'react'

export const BeAccountsApiContext = React.createContext({ apiContext: null })
